import { createFileRoute } from '@tanstack/react-router';

import { routeRequirements } from '../../lib/access/index.js';
import { RouteGuard } from '../../lib/route-guard.js';

export const INVENTORY_REQUIRED_PERMISSIONS = routeRequirements('/inventory');

export const Route = createFileRoute('/inventory')({
  component: () => <RouteGuard route="/inventory" />,
});
